import { NumberSymbol, getLocaleNumberSymbol } from '@angular/common';
import { Injectable } from '@angular/core';

import { EarlyPayoutConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { MoneyService } from '@frontend/sports/common/core/feature/money';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { Page } from '@frontend/vanilla/core';

import { AutocashoutValidation, CashoutSettingsBetInfo } from '../../../../my-bets-base/models/early-payout';

@Injectable()
export class MyBetsEarlyPayoutAutocashoutValidationService {
    constructor(
        private m2Page: Page,
        private sitecore: Sitecore,
        private epConfig: EarlyPayoutConfig,
        private interpolationPipe: StringInterpolationPipe,
        private moneyService: MoneyService,
    ) {}

    isValueValid(value: number, betInfo: CashoutSettingsBetInfo | null): AutocashoutValidation {
        if (!betInfo) {
            return {
                valid: false,
                errorMessage: this.sitecore.earlyPayoutErrors.AutoCashoutGeneralError,
            };
        }
        const autocashoutvalue = value;
        const maxValue = betInfo.isFreeBet ? betInfo.possibleWinnings : betInfo.grossPossibleWinnings;
        if (!maxValue || autocashoutvalue >= maxValue.value) {
            const maxAmount = maxValue ? Number((maxValue.value - 0.01).toFixed(2)) : 0;

            return {
                valid: false,
                errorMessage: this.interpolationPipe.transform(this.sitecore.earlyPayoutV2.SetAutocashoutMaxValueError, {
                    amountWithCurrency: this.moneyService.transform(this.localizeValue(maxAmount), true),
                }),
            };
        }

        const earlyPayoutValue = betInfo.earlyPayout?.valueWithoutStake || betInfo.earlyPayout?.value;
        if (
            betInfo.earlyPayout &&
            ((!earlyPayoutValue && autocashoutvalue < this.epConfig.autoCashOutMarginValue) ||
                (earlyPayoutValue && autocashoutvalue < Number((earlyPayoutValue + this.epConfig.autoCashOutMarginValue).toFixed(2))))
        ) {
            const val = earlyPayoutValue || 0;
            const localizedMinAmount = this.localizeValue((val + this.epConfig.autoCashOutMarginValue).toFixed(2)).toString();

            return {
                valid: false,
                errorMessage: this.interpolationPipe.transform(this.sitecore.earlyPayoutV2.SetAutocashoutMinValueError, {
                    amountWithCurrency: this.moneyService.transform(localizedMinAmount, true),
                }),
            };
        }

        return {
            valid: true,
            errorMessage: '',
        };
    }

    localizeValue(val: string | number): string {
        const separator = getLocaleNumberSymbol(this.m2Page.locale, NumberSymbol.Decimal);
        let returnVal: string = val.toString();
        returnVal = returnVal.replace(',', separator);
        returnVal = returnVal.replace('.', separator);

        return returnVal;
    }
}
